import { Capacitor } from "@capacitor/core";

/**
 * SULL'APP PER IPHONE: ISCRIZIONE SÌ, INVITI A COMPRARE NO (Apple 3.1.1).
 *
 * Il 29/09/2026 Apple ha respinto la build 8: «The app includes an account
 * registration feature for businesses and organizations, which is considered
 * access to external mechanisms for purchases». Il punto non era l'iscrizione:
 * era il muro dopo i 7 giorni, con «richiedi l'attivazione a Datacom» e i tasti
 * che portavano alla richiesta. Per Apple quello è un invito a comprare fuori.
 *
 * Decisione di Davide (29/09): l'iscrizione resta nell'app anche su iPhone, e
 * crea un account GRATUITO che non scade (gli strumenti restano sempre liberi,
 * come le app «gratis + abbonamento sul sito»: Spotify, Slack). Dentro l'app
 * iOS però nessun prezzo, nessun tasto o testo che porti a richiedere o
 * comprare l'account installatore: la licenza si propone FUORI dall'app (mail
 * di benvenuto e del 5° giorno, Datacom al telefono), che Apple consente.
 *
 * Il sito e l'app Android restano come sono.
 */
export function invitiAllAcquistoNellApp(): boolean {
  return Capacitor.getPlatform() !== "ios";
}

/** Testi neutri per l'iPhone, al posto di quelli che mandano a Datacom per l'attivazione. */
export const TESTI_IOS = {
  valutazioneFinita:
    "Il periodo di valutazione dell'assistente è terminato. Gli strumenti di calcolo restano a tua disposizione.",
  accessoNonAttivo:
    "L'assistente non è attivo per il tuo account in questo momento. Gli strumenti di calcolo restano a tua disposizione.",
  quotaSettimana: "Hai raggiunto le domande di questa settimana: il conteggio riparte lunedì.",
  quotaValutazione: "Hai usato le domande del periodo di valutazione. Gli strumenti di calcolo restano a tua disposizione.",
} as const;
